<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="pack-detail">
      <div class="pack-area">
        <ProductBanner
          v-if="currentPack"
          :packItem="currentPack"
          :showDetail="true"
        />
        <div v-if="currentPack" class="detail_area">
          <div class="name">
            {{currentPack.name}}
            <span class="red_message">{{t('残数')}}
              {{currentPack.pack_count | comma}}{{t('パック')}}
            </span>
          </div>
          <div class="point_base_area">
            <div class="count_base_area_block">
              <ErrorMessage
                v-if="errorMessageCount"
                class="error-message"
                :message="errorMessageCount"
              />
              <div class="count_base_area">
                <div class="count_area">
                  <span>{{t('購入数')}}</span>
                  <SelectBox
                    class="select_box"
                    :options="buyList"
                    selectedOption="1"
                    @handleSelectChange="changeCount" />
                </div>
              </div>
              <div class="limit_message" v-if="currentPack.can_limit === 1">
                {{currentPack.limit_message}}
              </div>
            </div>
            <div class="point_area">
              <span>商品合計</span>
              <span class="point">{{currentPack.point * count | comma}}
                <span v-if="currentPack.payment_method == '1'">P</span>
                <span v-if="currentPack.payment_method == '2'">C</span>
              </span>
            </div>
            <div class="buttons">
              <BlackGradationButton
                v-if="currentPack.can_limit === 0 && !isCountdown"
                class="square-button"
                :text="t('ガチャを回す')"
                @handleSquareBtnClick="goToConfirmBuyProduct"
              />
              <div class="limit_message" v-if="errorMessageCount">{{ errorMessageCount }}</div>
              <div class="countdown" v-if="isCountdown">
                <span class="label_title">{{t('販売開始まで')}}</span>
                <span class="num">{{countdownStr}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="currentPackCardList" class="card_list_area">
        <Title
          eng="LINE UP"
          :jpn="t('ラインナップ')"
          :small="true"
        />
        <div class="card_list">
          <img
            v-for="(row, key) in currentPackCardList.list"
            :key="key"
            :src="row.image_url"
            @click="handleDetailCard(row)"
          >
        </div>
        <div class="list_comment">{{t('表示されている商品はガチャから排出されるものです')}}</div>
        <BoxPager
          v-if="
            currentPackCardList &&
            currentPackCardList.page.pages.length > 0
          "
          class="box-pager"
          :totalPageCount="currentPackCardList.page.all_page"
          :currentPageCount="currentPackCardList.page.page"
          :dispBoxCount="currentPackCardList.page.pages.length"
          :pages="currentPackCardList.page.pages"
          @handlePagerClick="changeCurrentPageCount"
          @handleSquareBtnClick="changeCurrentPageCount"
        />
      </div>

      <div v-if="currentPack.format_end_date" class="end_date">
        <span>{{ currentPack.format_end_date }} 販売終了</span>
      </div>

      <div class="detail_block">
        <ProductDescription
          v-if="currentPack"
          :title="t('商品説明')"
          :description="setShopLink(currentPack.detail)"
        />
      </div>
    </div>
    <div v-if="showCardDetail" class="popup_card_area" @click.self="showCardDetail = false">
      <div class="popup_card">
        <div class="left">
          <img :src="popupCardData.image_url">
        </div>
        <div class="right">
          <div>{{popupCardData.name}}</div>
          <div>{{popupCardData.model_number}}</div>
          <div>{{popupCardData.rarity}}</div>
        </div>
      </div>
    </div>
    <CommonOverlay class="overlay" v-show="isOpenModal">
      <CommonModal v-if="currentPack.payment_method == '1'" class="modal">
        <div class="modal-title">
          <span>{{t('ポイント不足')}}</span>
        </div>
        <div class="text">
          <span>{{t('ポイントが不足しています。')}}</span>
          <span>{{t('購入しますか？')}}</span>
        </div>
        <div class="modal-button-area">
          <SquareButton
            class="square-button"
            :text="t('いいえ')"
            :isSub="true"
            @handleSquareBtnClick="closeModal"
          />
          <BlackGradationButton
            class="square-button"
            :text="t('はい')"
            @handleSquareBtnClick="goToBuyPoint"
          />
        </div>
      </CommonModal>
      <CommonModal v-if="currentPack.payment_method == '2'" class="modal">
        <div class="modal-title">
          <span>コイン不足</span>
        </div>
        <div class="text">
          <span>コインが不足しています。</span>
        </div>
        <div class="modal-button-area">
          <SquareButton class="square-button" text="閉じる" :isSub="true" @handleSquareBtnClick="closeModal" />
        </div>
      </CommonModal>
    </CommonOverlay>
    <CommonOverlay v-if="currentPack" class="overlay" v-show="isOpenConfirm">
      <CommonModal class="modal pack-confirm">
        <div class="modal-title">
          <span>{{currentPack.name}}</span>
        </div>
        <div v-if="currentPack.payment_method == '1'" class="bay_area">
          <div class="modal-subtitle">
            <span>{{t('使用ポイント')}}</span>
          </div>
          <div class="modal-point">
            <span class="point-area">{{currentPack.point * count | comma}}</span>
          </div>
          <div class="modal-label">保有ポイント</div>
          <div class="use-point">
            <div class="point-area">{{ currentUser.point | comma }}P</div>
            <div>→</div>
            <div class="point-area">{{ currentUser.point - (currentPack.point * count) | comma }}P</div>
          </div>
        </div>
        <div v-if="currentPack.payment_method == '2'" class="bay_area">
          <div class="modal-subtitle">
            <span>使用コイン</span>
          </div>
          <div class="modal-point">
            <span class="point-area">{{currentPack.point * count | comma}}C</span>
          </div>
          <div class="modal-label">保有コイン</div>
          <div class="use-point">
            <div class="point-area">{{ currentUser.coin | commaFloat }}C</div>
            <div>→</div>
            <div class="point-area">{{ currentUser.coin - (currentPack.point * count) | commaFloat }}C</div>
          </div>
        </div>
        <div class="buy-pack-area">
          <span>購入パック数</span>
          <span>{{ count | comma }}</span>
        </div>
        <div v-if="currentPack.payment_method == '2'" class="attention">
          <span>本商品はポイント還元不可(発送のみとなります)の商品となります。予めご容赦くださいませ。</span>
        </div>
        <div class="modal-button-area">
          <SquareButton
            class="square-button"
            :text="t('いいえ')"
            :isSub="true"
            @handleSquareBtnClick="closeModal"
          />
          <BlackGradationButton
            class="square-button"
            :text="t('購入を確定')"
            @handleSquareBtnClick="buyPack"
          />
        </div>
      </CommonModal>
    </CommonOverlay>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  separateCharacterNumber,
  separateDecimalNumber,
} from '@/common/util/format';

import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';
import ProductBanner from '@/components/molecules/ProductBanner.vue';
import ProductDescription from '@/components/molecules/ProductDescription.vue';
import SquareButton from '@/components/atoms/SquareButton.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import SelectBox from '@/components/atoms/SelectBox.vue';
import Title from '@/components/molecules/Title.vue';
import BoxPager from '@/components/organisms/BoxPager.vue';
import t from '@/plugins/i18n';
import { shopLink } from '@/common/config/js/const';

export default {
  name: 'PackDetail',
  mixins: [t],

  components: {
    BaseTemplate,
    CommonOverlay,
    CommonModal,
    ProductBanner,
    ProductDescription,
    SquareButton,
    BlackGradationButton,
    SelectBox,
    Title,
    BoxPager,
  },

  data: () => ({
    isOpenModal: false,
    errorMessageCount: null,
    count: 1,
    showCardDetail: false,
    isOpenConfirm: false,
    popupCardData: {},
    isCountdown: false,
    countdownStr: '',
  }),

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      currentPack: 'pack/currentPack',
      currentPackCardList: 'pack/packCardList',
      packCheckResult: 'pack/packCheckResult',
      setCheckPackResult: 'pack/setCheckPackResult',
      buyPackResult: 'pack/buyPackResult',
    }),
    packPoint() {
      if (this.currentPack) {
        return separateCharacterNumber(this.currentPack.point);
      }
      return 0;
    },
    isAvailable() {
      return parseInt(this.currentUser.point, 10) >= parseInt(this.currentPack.point, 10);
    },
    packCount() {
      if (this.currentPack) {
        return separateCharacterNumber(this.currentPack.pack_count);
      }
      return 0;
    },
    buyList() {
      if (!this.packCount) {
        return [];
      }
      const count = parseInt(this.packCount.replace(',', ''), 10);
      let max = count;
      if (max > 3000) {
        max = 3000;
      }
      const maxCount = parseInt(this.currentPack.max_buy_count, 10);
      if (maxCount > 0 && max > maxCount) {
        max = maxCount;
      }
      const option = [];
      for (let i = 1; i <= max; i += 1) {
        option.push({ id: i, name: `${i}${this.t('パック')}` });
      }
      return option;
    },
  },

  created() {
    const { errorMessageCount } = this.$route.query;
    this.errorMessageCount = errorMessageCount ? errorMessageCount[0] : null;
    this.$store.dispatch('pack/setCurrentPack', { packId: this.$route.query.packId });
  },

  // beforeDestroy() {
  //   this.$store.dispatch('pack/clearCurrentPack');
  // },

  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
    commaFloat(value) {
      return separateDecimalNumber(value, true);
    },
  },

  watch: {
    packCheckResult(newVal) {
      if (newVal) {
        if (newVal.state === 200 && newVal.result === '1') {
          // const query = {
          //   packId: this.$route.query.packId,
          //   buyCount: this.count,
          // };
          this.$store.dispatch('pack/clearPackCheckResult');
          // this.$router.push({ path: '/confirm-buy-product', query });
          this.isOpenConfirm = true;
        } else {
          const { count } = newVal.errors;
          this.errorMessageCount = count ? count[0] : null;
          this.isOpenModal = true;
        }
      }
    },
    currentPack(newVal) {
      if (newVal) {
        if (!newVal.id) {
          window.location.href = '/';
        }
        if (newVal.is_before) {
          this.isCountdown = true;
          this.setTimerID = setInterval(() => {
            this.setCountdownString();
          }, 1000);
          this.setCountdownString();
        }
        if (newVal.show_cardlist === '1') {
          this.$store.dispatch('pack/setPackCardList', { packId: newVal.id, pageNumber: 1 });
        } else {
          this.$store.dispatch('pack/clearPackCardList');
        }
      }
    },
  },

  methods: {
    setCountdownString() {
      const day1 = new Date(this.currentPack.start_date.replace(/-/g, '/'));
      const day2 = new Date();
      const diffDay = day1 - day2;
      if (diffDay < 0) {
        console.log('stop');
        this.isCountdown = false;
        console.log(this.isCountdown);
        clearInterval(this.setTimerID);
        return;
      }
      const h = `0${parseInt(diffDay / (1000 * 60 * 60), 10)}`.slice(-2);
      const m = `0${parseInt((diffDay % (1000 * 60 * 60)) / (1000 * 60), 10)}`.slice(-2);
      const s = `0${parseInt((diffDay % (1000 * 60)) / (1000), 10)}`.slice(-2);
      // const ms = `00${parseInt((diffDay % 1000), 10)}`.slice(-3);
      // this.countdownStr = `${h}.${m}.${s}.${ms}`;
      this.countdownStr = `${h}.${m}.${s}`;
    },
    // buyPack() {
    //   const query = {
    //     packId: this.$route.query.packId,
    //   };
    //   // ログインしていない場合、ログイン画面へ。routerのbeforeEachだとエラーが出る。（リダイレクトはされる）
    //   if (this.currentUser.is_login === '0') {
    //     this.$router.push({ path: '/login', query });
    //     return;
    //   }
    //   // 商品購入画面へ
    //   if (this.isAvailable) {
    //     this.$router.push({ path: '/buy-product', query });
    //     return;
    //   }
    //   this.isOpenModal = true;
    // },
    changeCount(val) {
      this.count = parseInt(val, 10);
    },
    closeModal() {
      this.isOpenModal = false;
      this.isOpenConfirm = false;
    },
    goToBuyPoint() {
      // ポイント購入画面へ
      const query = { packId: this.$route.query.packId };
      this.$router.push({ path: '/buy-point', query });
    },
    goToConfirmBuyProduct() {
      if (this.currentUser.is_login === '0') {
        this.$router.push({ path: '/login' });
        return;
      }
      const postParams = {
        count: String(this.count),
      };
      this.$store.dispatch('pack/setCheckPackResult', { postParams });
    },
    changeCurrentPageCount(page) {
      this.$store.dispatch('pack/setPackCardList', { packId: this.currentPack.id, pageNumber: page });
    },
    handleDetailCard(row) {
      this.popupCardData = row;
      this.showCardDetail = true;
    },
    buyPack() {
      (async () => {
        await this.$store.dispatch('pack/buyPack');
        const { buyPackResult } = this;
        const isSuceess = buyPackResult.state === 200 && buyPackResult.result === '1';
        if (isSuceess) {
          this.$store.dispatch('pack/clearBuyPackResult');
          this.$router.push('/gacha-animation');
        } else {
          const { count } = buyPackResult.errors;
          window.alert(count);
          this.isOpenConfirm = false;
        }
      })();
    },
    setShopLink(detail) {
      let result = detail;
      Object.keys(shopLink).forEach((key) => {
        const regex = new RegExp(key.replace(/[()]/g, '\\$&'), 'g');
        result = result.replace(regex, `<a href="${shopLink[key]}" target="_blank">${key}</a>`);
      });
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
.pack-detail{
  width: 100%;
  max-width: 780px;
  min-height: 100vh;
  padding: 30px 20px 26px 20px;
  margin: 0px auto;
  .pack-area {
    display: flex;
    padding: 0 50px;
    align-items: center;
  }
  .description-box{
    margin-top: 30px;
    border: 1px solid $white;
  }
  .buy-area{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    .point-box{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 185px;
      height: 50px;
      .value-point{
        font-family: $notoSerif;
        font-size: 24px;
        font-weight: 700;
        color: $gold;
      }
    }
    .square-button{
      width: 120px;
      height: 50px;
      margin-left: 30px;
    }
  }
}
.overlay{
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 30px;
  z-index: 1;
  .modal{
    padding: 40px 28px;
    font-family: $notoSans;
    color: $black;
    text-align: center;
    width: auto;
    .modal-title{
      font-size: 20px;
      font-weight: 700;
    }
    .text{
      display: flex;
      flex-direction: column;
      margin-top: 20px;
      font-size: 16px;
      font-weight: 400;
      line-height: 28px;
    }
    .modal-button-area{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 30px;
      .square-button{
        width: 120px;
        height: 50px;
        & + .square-button{
          margin-left: 20px;
        }
      }
    }
  }
}
.pack-confirm {
  .modal-title {
    color: $mainColor;
    margin-bottom: 10px;
  }
  .modal-subtitle {
    font-weight: bold;
  }
  .point-area {
    position: relative;
    &:before {
      // content: "P";
      border: solid 1px $mainColor;
      position: absolute;
      left: 0;
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: $mainColor;
      border-radius: 100px;
    }
  }
  .modal-label {
    text-align: left;
    font-size: 14px;
  }
  .modal-point {
    font-size: 32px;
    font-weight: bold;
    margin: 10px 0 10px 50px;
    .point-area {
      &:before {
        left: -50px;
        top: 5px;
      }
    }
  }
  .use-point {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding-bottom: 10px;
    .point-area {
      margin: 10px 0 10px 30px;
      &:before {
        left: -30px;
        top: 1px;
        height: 25px;
        width: 25px;
        font-size: 14px;
      }
    }
  }
  .buy-pack-area {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    font-size: 14px;
    padding-top: 10px;
    border-top: solid 2px $black;
    span {
      &:last-child {
        font-size: 32px;
        &:after {
          content: "パック";
          font-size: 14px;
        }
      }
    }
  }
}
.detail_area {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 10px;
  color: $black;
  font-size: 18px;
  width: 500px;
  .card_type {
    color: $yellow;
    font-size: 14px;
    text-align: center;
  }
  .name {
    color: $black;
    font-size: 42px;
    font-weight: bold;
    .red_message {
      display: block;
      font-size: 24px;
      font-weight: normal;
      color: $black;
    }
  }
  .point_base_area {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin: 30px auto 0 auto;
    max-width: 500px;
    .point_area {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      font-size: 14px;
      padding: 10px 0;
      border-top: solid 1px $black;
      .point {
        font-weight: 700;
        color: $black;
        font-size: 24px;
        &:after {
          // content: "P";
          width: 20px;
          height: 20px;
          color: $black;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          background-color: $white;
          border-radius: 100px;
        }
      }
    }
    .count_base_area_block {
      color: $black;
      width: 100%;
      padding: 10px 0;
      .count_base_area {
        display: flex;
        justify-content: space-between;
        .count_area {
          width: 100%;
          display: flex;
          font-size: 14px;
          align-items: center;
          justify-content: space-between;
          .select_box {
            width: 120px;
            margin-left: 10px;
          }
        }
      }
    }
  }
}
.buttons {
  margin: 10px auto 0 auto;
  width: 100%;
  .square-button {
    width: 100%;
  }
}
.limit_message {
  font-size: 14px;
  color: #f00;
}
.card_list_area {
  margin-top: 20px;
  .card_list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-bottom: 20px;
    margin-top: 20px;
    img {
      height: 120px;
      margin: 4px;
    }
  }
  .list_comment {
    color: $black;
    text-align: center;
    margin-bottom: 20px;
  }
}
.detail_block {
  margin-top: 20px;
  padding: 20px;
}
.popup_card_area {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .popup_card {
    padding: 20px 40px;
    background-color: #fff;
    .left {
      text-align: center;
    }
    .right {
      margin-top: 20px;
      font-size: 18px;
      text-align: center;
    }
  }
}

.countdown {
  margin-top: -5px;
  display: flex;
  justify-content: center;
  align-items: center;
  //color: #c00;
  height: 68px;
  span.num {
    color: #FF8C00;
    background: -webkit-linear-gradient(0deg, #40E0D0, #FF8C00, #FF0080);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 36px;
    font-family: seven-segment!important;
  }
  span.label_title {
    font-size: 12px;
    margin-right: 10px;
    color: #fff;
  }
}
.end_date {
  text-align: center;
  margin-top: 20px;
  color: red;
  font-weight: bold;
}
@media screen and (max-width: $tabletWidth) {
  .pack-detail {
    padding: 0 20px 26px 20px;
    .detail_block {
      margin-top: 30px;
      padding: 0;
    }

    .point_base_area {
      flex-direction: column;
      margin-top: 0;
      .point_area {
        width: 100%;
        text-align: center;
      }

      .count_base_area_block {
        width: 100% !important;
        padding: 10px 0 0 0;

        .count_base_area {
          flex-direction: column;
          align-items: center;

          .count_area {
            margin: 20px 0;
          }
        }
      }
    }
    .pack-area {
      flex-direction: column;
      padding: 10px 20px 10px 20px;
      align-items: normal;
      .detail_area {
        width: auto;
        .name {
          display: none;
        }
      }
    }
  }
  .card_list_area {
    margin-top: 20px;
    .card_list {
      display: flex;
      margin-bottom: 20px;
      img {
        height: 90px;
        margin: 2px;
      }
    }
  }
  .buttons {
    margin: 0 auto;
    max-width: 500px;
    .square-button {
      width: 100%;
    }
  }
  .countdown {
    font-size: 18px;
    flex-direction: column;
    span.num {
      font-size: 24px;
    }
  }
  .detail_block {
    margin-top: 10px;
  }
  .overlay {
    .modal {
      width: 90%;
      .modal-button-area {
        flex-direction: column-reverse;
        .square-button {
          & + .square-button{
            margin-left: 0px;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}
.attention {
  font-size: 12px;
  margin-top: 20px;
  color: red;
}
</style>
